import * as React from "react";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WhatIfToolDetailModel } from "../../../../../../Wrap/Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Withdrawals } from "../../Common/Withdrawals/Withdrawals";

interface IAddEditRegularWithdrawalsProps extends IProcessComponentProps {
    type: SubAccountType;
    extraInfo: WhatIfToolDetailModel;
}

interface IAddEditRegularWithdrawalsState {}

export class AddEditRegularWithdrawals extends ProcessComponent<
    IAddEditRegularWithdrawalsProps,
    IAddEditRegularWithdrawalsState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { type, data } = this.props;
        return (
            <>
                <Alert
                    alertType={AlertType.Warning}
                    message={
                        "For the purposes of this 'What if quote' the withdrawals are assumed to be taken proportionately"
                    }
                />
                <Withdrawals
                    {...this.props}
                    extraInfoWhatIf={this.props.extraInfo}
                    modelName="Contribution"
                    type={ProcessType.WhatIf}
                    onRef={(ref) => this.appendChild(ref)}
                />
            </>
        );
    }
}
